export function getImageRatio({
  width,
  height,
}: {
  width: number;
  height: number;
}) {
  if (!width || !height) {
    return 0;
  }
  return height / width;
}
